import { storyblokEditable } from "gatsby-source-storyblok"
import React from "react"

import MasterBulletPoints from "../../../../../V2/Cards/Content/MasterBulletPoints"

import { storyblokLinkToYocoLink } from "@utils/storyblok"

const StoryblokBulletPointListItemsCard = ({
  blok,
  mobileGridOrder,
}: Storyblok.BlokProps<Storyblok.BulletPointListItemsCard>) => {
  return (
    <MasterBulletPoints
      itemType="list_items"
      title={blok.headerText}
      linkText={blok.ctaText}
      linkColor={blok.ctaColor}
      listItems={blok.listInfoBlocks}
      priceBadge={blok.priceBadge?.[0]}
      backgroundColor={blok.backgroundColor}
      linkUrl={storyblokLinkToYocoLink(blok.ctaLink)}
      mobileGridOrder={mobileGridOrder}
      trackingEvent={blok.trackingEvent}
      trackingEventKey={blok.trackingEventKey}
      trackingEventValue={blok.trackingEventValue}
      // @ts-ignore to have more strict typing compared to Storybloks generic object typing
      {...storyblokEditable(blok)}
    />
  )
}

export default StoryblokBulletPointListItemsCard
